export default "__VITE_ASSET__752_JBgc__"